/**
 * Survey & Survey Blocks Sheet Icons
 *
 * Icons used in SurveyBlocksSheet (block list, page list, back, close)
 * and all icons that survey calculatedValues may return for page icons
 * (e.g. circle, circle-check, star, heart, sparkles, folder, user, stethoscope).
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faXmark as fasXmark,
  faCircle as fasCircle,
  faCircleCheck as fasCircleCheck,
  faCheck as fasCheck,
  faStar as fasStar,
  faHeart as fasHeart,
  faFolder as fasFolder,
  faUser as fasUser,
  faArrowRight as fasArrowRight,
  faShieldHalved as fasShieldHalved,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCircle as fadCircle,
  faCircleCheck as fadCircleCheck,
  faStar as fadStar,
  faHeart as fadHeart,
  faFolder as fadFolder,
  faUser as fadUser,
  faSparkles as fadSparkles,
  faStethoscope as fadStethoscope,
  faFileMedical as fadFileMedical,
  faNotesMedical as fadNotesMedical,
  faClipboard as fadClipboard,
  faHouseMedical as fadHouseMedical,
  faHeartPulse as fadHeartPulse,
  faUserDoctor as fadUserDoctor,
  faUtensils as fadUtensils,
  faDumbbell as fadDumbbell,
  faBed as fadBed,
  faWeightScale as fadWeightScale,
  faPills as fadPills,
  faPrescriptionBottle as fadPrescriptionBottle,
  faCalendarDays as fadCalendarDays,
  faChartLine as fadChartLine,
  faListCheck as fadListCheck,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadSurveyIcons = () => {
  library.add(
    // SurveyBlocksSheet UI
    fasChevronLeft,
    fasChevronRight,
    fasXmark,
    fasCircle,
    fasCircleCheck,
    fasCheck,
    fasStar,
    fasHeart,
    fasFolder,
    fasUser,
    fasArrowRight,
    // Page icons (fad — match web SurveySuggestions / SurveyDataProvider)
    fadCircle,
    fadCircleCheck,
    fadStar,
    fadHeart,
    fadFolder,
    fadUser,
    fadSparkles,
    fadStethoscope,
    fadFileMedical,
    fadNotesMedical,
    fadClipboard,
    fadHouseMedical,
    fadHeartPulse,
    fadUserDoctor,
    fadUtensils,
    fadDumbbell,
    fadBed,
    fadWeightScale,
    fadPills,
    fadPrescriptionBottle,
    fadCalendarDays,
    fadChartLine,
    fadListCheck,
    fasShieldHalved
  );
};
